import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { generate } from 'short-uuid';
import { DocumentType } from 'core/types/document';
import executePlugin from '../plugins/utils/execution';

import { TYPE_CHAPTERS, TYPE_COVER } from './constants';
import { findDocument } from './utils/find-document';
import shortcodes from './utils/shortcodes';
import traverse from './utils/traverse';
import findPluginsRefDocument from '../plugins/utils/find';

export const htmlRedner = async ({ items, tree }: any, call: any = (item: any) => item) => {
  const content: any[] = [];
  const { _id, title, type: chapterType, parent } = findDocument(items, tree.id);
  const pluginsDocument = findPluginsRefDocument(_id, parent, items);

  // escape showing the first type chapters
  const data = chapterType === TYPE_CHAPTERS ? tree?.children || [] : [tree];

  await traverse({ items, data, level: 0, path: [] }, async (item: any) => {
    const { _id: id, html, path, type } = await call(item);

    const executedHTML =
      type === DocumentType.PLUGINS ? '' : await executePlugin(html, pluginsDocument);

    const key = generate();
    const el: JSX.Element = React.createElement('div', {
      className: type,
      id: type !== TYPE_COVER ? key : '',
      key,
      dangerouslySetInnerHTML: { __html: shortcodes({ html: executedHTML, path, id }) },
    });

    content.push(ReactDOMServer.renderToString(el));
  });

  const body = content.join('');

  return {
    title,
    body,
  };
};
